import { useTranslate } from '@tolgee/react'
import { TomAutoComplete, TomAutoCompleteProps } from '@tom-ui/ui'
import { ContainerType } from '@yard/app/api'
import { observer } from 'mobx-react-lite'
import { useState } from 'react'

type Props<M extends boolean = false> = {
  multiple?: boolean
  onChange: (containerType: M extends true ? ContainerType[] : ContainerType) => void
  validate?: () => void
} & TomAutoCompleteProps<ContainerType, M>

export const ContainerTypeAutoComplete = observer(<M extends boolean = false>(props: Props<M>) => {
  const { t } = useTranslate()
  const { dataCy, defaultValue, label, onChange } = props

  const [options] = useState<ContainerType[]>(Object.values(ContainerType))

  return (
    <TomAutoComplete
      {...props}
      dataCy={dataCy ?? 'container-type-autocomplete'}
      label={label ?? t('containerType', 'Container Type')}
      options={options}
      defaultValue={defaultValue}
      enablePortal
      placeholder={t('selectContainerType', 'Select container type')}
      onChangeEntity={entity =>
        onChange(entity as M extends true ? ContainerType[] : ContainerType)
      }
    />
  )
})
